var _excluded = ["as", "children", "className", "createChildProps", "dataTestId", "disabled", "error", "isAssertiveError", "label", "marginBottom", "marginLeft", "marginRight", "marginTop", "name", "optional", "supportiveText", "tooltip"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import classNames from 'classnames';
import React, { forwardRef } from 'react';
import StyledLabeledField from "./styled";
import { useBrand } from "../BrandProvider";
import FieldError from "../FieldError";
import FieldLabel from "../FieldLabel";
import SupportiveText from "../SupportiveText";
/**
 * Component pattern which is used by most other form field components,
 * such as TextField, Dropdown and RadioButtonGroup.
 **/
var LabeledField = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$as = _ref.as,
    as = _ref$as === void 0 ? 'div' : _ref$as,
    children = _ref.children,
    className = _ref.className,
    _ref$createChildProps = _ref.createChildProps,
    createChildProps = _ref$createChildProps === void 0 ? true : _ref$createChildProps,
    dataTestId = _ref.dataTestId,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    error = _ref.error,
    isAssertiveError = _ref.isAssertiveError,
    label = _ref.label,
    _ref$marginBottom = _ref.marginBottom,
    marginBottom = _ref$marginBottom === void 0 ? '07' : _ref$marginBottom,
    _ref$marginLeft = _ref.marginLeft,
    marginLeft = _ref$marginLeft === void 0 ? 'none' : _ref$marginLeft,
    _ref$marginRight = _ref.marginRight,
    marginRight = _ref$marginRight === void 0 ? 'none' : _ref$marginRight,
    _ref$marginTop = _ref.marginTop,
    marginTop = _ref$marginTop === void 0 ? 'none' : _ref$marginTop,
    name = _ref.name,
    _ref$optional = _ref.optional,
    optional = _ref$optional === void 0 ? false : _ref$optional,
    supportiveText = _ref.supportiveText,
    tooltip = _ref.tooltip,
    rest = _objectWithoutProperties(_ref, _excluded);
  var isFieldset = as === 'fieldset';
  var labelProps = {
    'aria-describedby': isFieldset ? undefined : "".concat(name, "-hint ").concat(name, "-error"),
    htmlFor: isFieldset ? undefined : name
  };
  var _ref2 = useBrand() || {},
    _ref2$testAttributeNa = _ref2.testAttributeName,
    testAttributeName = _ref2$testAttributeNa === void 0 ? 'data-qa-id' : _ref2$testAttributeNa;
  var testAttributes;
  var getTestAttributes = function getTestAttributes(element) {
    var _testAttributes;
    return ((_testAttributes = testAttributes) === null || _testAttributes === void 0 ? void 0 : _testAttributes[element]) || {};
  };
  if (dataTestId) {
    testAttributes = {};
    testAttributes.default = _defineProperty({}, testAttributeName, dataTestId);
    testAttributes.error = _defineProperty({}, testAttributeName, "".concat(dataTestId, "-error"));
    testAttributes.hint = _defineProperty({}, testAttributeName, "".concat(dataTestId, "-hint"));
    testAttributes.input = _defineProperty({}, testAttributeName, "".concat(dataTestId, "-input"));
    testAttributes.label = _defineProperty({}, testAttributeName, "".concat(dataTestId, "-label"));
  }
  var isReactElement = function isReactElement(element) {
    return /*#__PURE__*/React.isValidElement(element);
  };
  return /*#__PURE__*/React.createElement(StyledLabeledField, _extends({
    $marginBottom: marginBottom,
    $marginLeft: marginLeft,
    $marginRight: marginRight,
    $marginTop: marginTop
  }, getTestAttributes('default'), rest, {
    "aria-describedby": isFieldset ? "".concat(name, "-hint ").concat(name, "-error") : undefined,
    as: as,
    className: classNames(children && 'csl-field', className),
    ref: ref
  }), typeof label === 'string' && /*#__PURE__*/React.createElement(FieldLabel, _extends({}, getTestAttributes('label'), labelProps, {
    as: isFieldset ? 'legend' : 'label',
    optional: optional
  }), label), isFieldset && _typeof(label) === 'object' && /*#__PURE__*/React.createElement("legend", null, label), !isFieldset && _typeof(label) === 'object' && isReactElement(label) && /*#__PURE__*/React.cloneElement(label, {}, /*#__PURE__*/React.createElement("label", labelProps, label.props.children)), /*#__PURE__*/React.createElement(SupportiveText, _extends({}, getTestAttributes('hint'), {
    id: "".concat(name, "-hint")
  }), supportiveText), tooltip && /*#__PURE__*/React.createElement(SupportiveText, null, tooltip), /*#__PURE__*/React.createElement(FieldError, _extends({}, getTestAttributes('error'), {
    id: "".concat(name, "-error"),
    isAssertive: isAssertiveError
  }), error), children && React.Children.map(children, function (child) {
    var _props, _props2;
    return /*#__PURE__*/React.cloneElement(child, createChildProps ? _objectSpread(_objectSpread({}, getTestAttributes('input')), {}, {
      'aria-describedby': "".concat(name, "-hint ").concat(name, "-error"),
      disabled: (child === null || child === void 0 ? void 0 : (_props = child.props) === null || _props === void 0 ? void 0 : _props.disabled) !== undefined ? child === null || child === void 0 ? void 0 : (_props2 = child.props) === null || _props2 === void 0 ? void 0 : _props2.disabled : disabled,
      error: Boolean(error)
    }) : {});
  }));
});
LabeledField.displayName = 'LabeledField';
export default LabeledField;